import React from 'react';
import ReactDOM from 'react-dom';
import shallowEqual from 'react-pure-render/shallowEqual';

export default class BaseComponent extends React.Component {

  constructor(props, stores){
    super(props);
    this.stores = stores || [];
    this.handleStoresChanged = this.handleStoresChanged.bind(this);
    this.state = this.getState(props);
  }

  getState(){}

  get stores(){
    return this._stores;
  }

  set stores(storeArray){
    this._stores = storeArray;
  }

  componentWillMount() {
    this.stores.forEach(store => {
      store.addChangeListener(this.handleStoresChanged)
    }
    );
  }

  get domNodeDataset() {
    const { parentNode } = ReactDOM.findDOMNode(this);
    return parentNode.dataset;
  }

  componentWillReceiveProps(nextProps) {
    if (!shallowEqual(nextProps, this.props)){
      let newState = this.getState(nextProps);
      if (newState){
        this.setState(newState);
      }
    }
  }

  componentWillUnmount(props) {
    this.stores.forEach(store => {
      store.removeChangeListener(this.handleStoresChanged);
    });
  }

  handleStoresChanged() {
    let newState = this.getState(this.props);
    if (newState){
      this.setState(newState);
    }
  }

}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/baseComponent.js